module.exports = __webpack_public_path__ + "30f8378cc86d3b9475b3e824eed8277f.svg";